import InfoIcon from "@mui/icons-material/InfoOutlined";
import type { TypographyProps } from "@mui/material";
import { Box, Stack } from "@mui/material";
import ExpandableTypography from "@entrilia/shared/components/ExpandableTypography";

interface Props {
  text: string;
}

const maxCollapsedLines = 2;

const textProps: TypographyProps<"p"> = {
  variant: "caption",
  color: "textSecondary",
  component: "p",
  sx: { whiteSpace: "pre-wrap" },
};

const WidgetFootnote = ({ text }: Props) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "flex-start", flexShrink: 0, pt: 2 }}>
    <InfoIcon color="action" sx={{ flexShrink: 0, fontSize: "1rem" }} />
    <Box sx={{ minWidth: 0 }}>
      <ExpandableTypography maxLines={maxCollapsedLines} typographyProps={textProps}>
        {text}
      </ExpandableTypography>
    </Box>
  </Stack>
);

export default WidgetFootnote;
